import { getObservableT } from "../Infra/i18next";
import { FormModel } from "./FormModel";
import { validators } from "../Logic/Validators";
import { PatientConsentLoginViewModel } from "./PatientConsentLoginViewModel";
const t = getObservableT("patients");
export class PatientConsentEmailCollectionViewModel extends PatientConsentLoginViewModel {
    constructor(container) {
        var _a;
        super(container);
        this.formModel = new FormModel({
            email: "",
        }, []);
        this.formModel.input.email = (_a = this.patientConsentUIManager.patientCollectedEmail) !== null && _a !== void 0 ? _a : "";
    }
    validateInput() {
        const { notBlank, validEmail } = validators;
        const f = this.formModel;
        f.clearErrors();
        f.validateField("email", notBlank, t("Enter an email address"));
        f.validateField("email", validEmail, t("Enter a valid email address"));
        return !f.hasErrors();
    }
    continue() {
        if (!this.validateInput())
            return;
        this.patientConsentUIManager.updatePatientCollectedEmail(this.formModel.input.email);
        this.verifyWithClearIfNeeded(this.isSandboxLogin);
    }
}
